import axiosClient from './axios.client';

export const userSignUp = async ({
  username,
  password,
}) => {
  try {
    const response = await axiosClient.post(
      'users/signup',
      { username, password },
    );

    return { response };
  } catch (err) {
    return { err };
  }
};

export const userSignIn = async ({
  username,
  password,
}) => {
  try {
    const response = await axiosClient.post(
      'users/signin',
      { username, password },
    );

    return { response };
  } catch (err) {
    return { err };
  }
};

export const userCheckTkn = async () => {
  try {
    const response = await axiosClient.get('users/check-token', {
      withCredentials: true, // 👈 CRITICAL for cookies/sessions
    });

    return { response };
  } catch (err) {
    return { err };
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    const response = await axiosClient.put('settings/profile', profileData);
    return { response };
  } catch (err) {
    return { err };
  }
};
